<div class="text-center">
  <!-- Icon should be dynamic, will handle this later -->
  <tix-icon class="!w-10 !h-10" svgIcon="calendar"></tix-icon>
  <h1 class="mt-2 text-xl font-medium text-gray-900">{{ title }}</h1>
  <p class="mt-1 text-sm text-gray-500">{{ subTitle }}</p>
</div>
